module.exports = __webpack_public_path__ + "res/img_landing_how_it_works1.aec2ddcea307bb972a18afda95e76aaa.webp";